import React, { useMemo } from "react";
import { Tooltip } from "@material-ui/core";

const CardBuySellOverlay = ({
  isHovered,
  onPurchase,
  onSell,
  canPurchase,
  canSell,
  buyPrice,
  sellPrice,
  selectedActionCard = null,
  actionMode = null,
  onApplyAction = null,
  roi = null,
  isMyTurn = false
}) => {
  const hasActions = useMemo(() => 
    onPurchase || onSell || onApplyAction, 
    [onPurchase, onSell, onApplyAction]
  );

  // Don't show overlay if it's not the player's turn
  if (!isMyTurn || !hasActions) {
    return null;
  }

  return (
    <div 
      className={`card-buy-sell-overlay ${isHovered ? 'card-buy-sell-overlay-visible' : ''}`}
    >
      {isHovered && (
        <>
          {selectedActionCard && actionMode && onApplyAction && (
            <Tooltip title={actionMode === "selecting_rug_pull" ? "Apply rug pull to sell all your holdings of this stock/index (uses 1 action)" : "Apply action card to this card (uses 1 action)"} arrow placement="top">
              <div 
                className="card-overlay-button card-overlay-button-apply"
                onClick={onApplyAction}
              >
                <div className="card-overlay-button-label">
                  ⚡APPLY
                </div>
                <div className="card-overlay-button-value">
                  ACTION
                </div>
              </div>
            </Tooltip>
          )}
          
          {onPurchase && !selectedActionCard && (
            <Tooltip title={canPurchase ? `Buy for $${buyPrice}` : "No actions remaining"} arrow placement="top">
              <div 
                className={`card-overlay-button ${canPurchase ? 'card-overlay-button-buy' : 'card-overlay-button-disabled'}`}
                onClick={onPurchase}
                disabled={!canPurchase}
              >
                <div className="card-overlay-button-label">
                  {canPurchase ? '⚡BUY' : 'NO ⚡'}
                </div>
                <div className={canSell ? 'card-overlay-button-value-large' : 'card-overlay-button-value-xl'}>
                  ${buyPrice}
                </div>
              </div>
            </Tooltip>
          )}

          {onSell && !selectedActionCard && canSell && (
            <Tooltip title={canSell ? `Sell for $${sellPrice}${roi !== null ? ` (${roi >= 0 ? '+' : ''}$${roi})` : ''}` : "No actions remaining"} arrow placement="top">
              <div 
                className={`card-overlay-button card-overlay-button-sell`}
                onClick={onSell}
                disabled={!canSell}
              >
                <div className="card-overlay-button-label">
                  ⚡SELL
                </div>
                <div className={`flex items-center gap-xs flex-wrap justify-center ${canPurchase ? 'card-overlay-button-value-large' : 'card-overlay-button-value-xl'}`}>
                  <span>${sellPrice}</span>
                  {roi !== null && canSell && (
                    <span className={`${canPurchase ? 'card-overlay-button-value' : 'card-overlay-button-label'} ${parseFloat(roi) >= 0 ? 'card-overlay-button-roi' : 'card-overlay-button-roi-negative'}`}>
                      ({parseFloat(roi) >= 0 ? '+' : ''}${roi})
                    </span>
                  )}
                </div>
              </div>
            </Tooltip>
          )}
        </>
      )}
    </div>
  );
};

export default CardBuySellOverlay;

